import { UserProfile } from '@teetsh/app/src/types/user';
import { createContext } from 'react';

const UserContext = createContext<UserProfile | undefined>(undefined);

export { UserContext };
